import { render, staticRenderFns } from "./_sidebar.vue?vue&type=template&id=241a06cd&scoped=true"
import script from "./_sidebar.vue?vue&type=script&lang=js"
export * from "./_sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241a06cd",
  null
  
)

export default component.exports